import { overflow, OverflowProps } from '@lib/style/mixins/overflow';
import { padding, PaddingProps } from '@lib/style/mixins/padding';
import MUIDialogContent, { DialogContentProps } from '@material-ui/core/DialogContent';
import React, { Fragment } from 'react';
import styled from 'styled-components';

type DialogCProps = Partial<PaddingProps & OverflowProps> &
    DialogContentProps & {
        component?: any;
        componentProps?: { [key: string]: any };
    };

export const DialogContent = styled(
    ({ component = Fragment, componentProps = {}, children, ...props }: DialogCProps) => {
        padding.clean(props);
        overflow.clean(props);

        const Component = component;

        return (
            <MUIDialogContent {...props}>
                <Component {...componentProps}>{children}</Component>
            </MUIDialogContent>
        );
    },
)`
    && {
        ${overflow('auto')} ${padding('0 20px')}
    }
`;
